'use client';

import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {useState} from 'react';
import {queryClient} from '#lib/query-client';

interface QueryProviderProps {
  children: React.ReactNode;
}

export default function QueryProvider({children}: QueryProviderProps) {
  // Create a new QueryClient instance for each user session
  // This ensures data isolation between users
  const [client] = useState(() => queryClient);

  return (
    <QueryClientProvider client={client}>
      {children}
      {/* Only show devtools in development */}
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools
          initialIsOpen={false}
          position="bottom"
          buttonPosition="bottom-right"
        />
      )}
    </QueryClientProvider>
  );
}
